export default __webpack_public_path__ + "static/media/logo.5b18a1e0.jpg";